import React, { useState } from "react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

interface Props {
  serviceId: number;
  serviceShortName: string;
  serviceName?: string;
}

const tabs = [
  { id: "overview", label: "Overview" },
  { id: "audience", label: "Target Audience" },
  { id: "deliverables", label: "Delivarables" },
  { id: "financials", label: "Financials" },
];

const JobReadinessAssistanceDSP: React.FC<Props> = ({
  serviceId,
  serviceShortName,
  serviceName = "Job Readiness Assistance",
}) => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
<section className="bg-gray-50 min-h-screen p-4">
      <div className="w-full mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Left Summary Card */}
        <div className="bg-white rounded-lg shadow-md p-8 border border-gray-200">
          <div className="flex flex-col items-center text-center">
            <div
              className="rounded-full flex items-center justify-center font-bold mb-4
                         h-24 w-24 sm:h-32 sm:w-32 lg:h-40 lg:w-40
                         bg-cover bg-center"
              style={{ backgroundImage: "url('assets/images/servicelogo2.png')" }}
            >
              <span className="bg-gradient-to-b from-yellow-600 to-yellow-900 bg-clip-text text-transparent
                               text-2xl sm:text-3xl lg:text-4xl">
                JRA
              </span>
            </div>

            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900">{serviceName}</h2>
            <p className="text-lg sm:text-xl text-gray-700 mt-3 leading-relaxed">
            </p>
          </div>

          {/* Key Features */}
          <div className="mt-8 space-y-4 text-lg sm:text-xl text-gray-800">
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-3">Key Features</h3>
            <div className="flex gap-2">
              <ChevronRightIcon className="h-6 w-6 text-blue-500" />
              <span></span>
            </div>
            <div className="flex gap-2">
              <ChevronRightIcon className="h-6 w-6 text-blue-500" />
              <span></span>
            </div>
            <div className="flex gap-2">
              <ChevronRightIcon className="h-6 w-6 text-blue-500" />
              <span></span>
            </div>
          </div>
        </div>

        {/* Right Tabbed Content */}
        <div className="md:col-span-2 bg-white rounded-lg shadow-md border border-gray-200">
          {/* Tabs */}
          <div className="flex border-b border-gray-200 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 text-lg sm:text-xl font-medium ${
                  activeTab === tab.id
                    ? "text-blue-600 border-b-2 border-blue-600"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="p-8 text-gray-800 text-lg sm:text-xl leading-relaxed">
            {activeTab === "overview" && (
              <>
    
              </>
            )}

            {activeTab === "audience" && (
              <>

              </>
            )}

            {activeTab === "deliverables" && (
              <>
  
              </>
            )}

            {activeTab === "financials" && (
              <>
    
              </>
            )}
          </div>
        </div>
      </div>
    </section>

  );
};

export default JobReadinessAssistanceDSP;
